import BaseService from './baseService';
const rota = 'recebimentos';
const service = new BaseService(rota);

export const getList = async (body, skip, limit) => {
    const res = await service.getList(body, skip, limit);
    return res;
}

export const getById = async (id) => {
    const res = await service.getById(id);
    return res;
}

export const reorder = async (body) => {
    const res = await service.reorder(body);
    return res;
}

export const upsert = async (body, id) => {
    const res = await service.upsert(body, id);
    return res;
}

export const get = async (rotaAdd) => {
    const res = await service.get(`${rota}/${rotaAdd}`);
    return res;
}

export const post = async (rotaAdd, body) => {
    const res = await service.post(`${rota}/${rotaAdd}`, body);
    return res;
}

export const postCompress = async (rotaAdd, body) => {
    const res = await service.postCompress(`${rota}/${rotaAdd}`, body);
    return res;
}
